<template>
  <div class="top-right-cmp">
    <!-- <div id="container" style="width: 100%; height: 350px">图标</div> -->
  </div>
</template>
<script>
//先导入charts
import Charts from "@jiaminghi/charts";
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style scoped>
.top-right-cmp {
  position: relative;
  padding: 0 50px;
  box-sizing: border-box;
}
</style>
